export enum GcpCorruptionType {
  REPLACE_BROKEN = 'REPLACE_BROKEN',
  REPLACE_SMALL = 'REPLACE_SMALL',
  CLEANUP_STUFF = 'CLEANUP_STUFF',
  CLEANUP_DIRT = 'CLEANUP_DIRT',
  CLEANUP_REPAINT = 'CLEANUP_REPAINT',
  FIX_COORDINATES = 'FIX_COORDINATES',
  OTHER = 'OTHER',
  CHECK_CONDITION = 'CHECK_CONDITION',
}
